var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 36,
    height: 36,
    rx: 1,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0574 3.59985L19.8691 12.6183L22.1357 7.30345L32.0574 3.59985Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94336 3.59985L16.0231 12.7025L13.8652 7.30344L3.94336 3.59985Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6707 24.5105L24.4277 29.4647L31.3718 31.3766L33.361 24.6188L27.6707 24.5105Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6543 24.6188L4.63141 31.3766L11.5634 29.4647L8.3325 24.5105L2.6543 24.6188Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1886 16.1415L9.25977 19.0515L16.1315 19.3641L15.9024 11.969L11.1886 16.1415Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8119 16.1417L20.0259 11.885L19.8691 19.3643L26.7408 19.0517L24.8119 16.1417Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 29.4648L15.7217 27.4567L12.1412 24.667L11.5625 29.4648Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2793 27.4567L24.4264 29.4648L23.8598 24.667L20.2793 27.4567Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4264 29.4649L20.2793 27.4568L20.6168 30.1503L20.5806 31.2926L24.4264 29.4649Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 29.4649L15.4203 31.2926L15.3962 30.1503L15.7217 27.4568L11.5625 29.4649Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4929 22.8874L12.0449 21.8774L14.4801 20.759L15.4929 22.8874Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5078 22.8874L21.5205 20.759L23.9678 21.8774L20.5078 22.8874Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5629 29.4647L12.1657 24.5105L8.33203 24.6188L11.5629 29.4647Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 24.5105L24.4267 29.4647L27.6696 24.6188L23.8359 24.5105Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7408 19.0513L19.8691 19.3639L20.5081 22.8872L21.5208 20.7588L23.9681 21.8771L26.7408 19.0513Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0446 21.8771L14.4798 20.7588L15.4926 22.8872L16.1315 19.3639L9.25977 19.0513L12.0446 21.8771Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25977 19.0513L12.1411 24.6668L12.0446 21.8771L9.25977 19.0513Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9679 21.8771L23.8594 24.6668L26.7407 19.0513L23.9679 21.8771Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1312 19.364L15.4922 22.8873L16.2999 27.0478L16.4808 21.5646L16.1312 19.364Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8689 19.364L19.5312 21.5526L19.7001 27.0478L20.5078 22.8873L19.8689 19.364Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5069 22.8873L19.6992 27.0478L20.2779 27.4566L23.8585 24.6669L23.9669 21.8772L20.5069 22.8873Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0449 21.8772L12.1414 24.6669L15.7219 27.4566L16.3006 27.0478L15.4929 22.8873L12.0449 21.8772Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5801 31.2926L20.6162 30.1503L20.3029 29.8857H15.6976L15.3962 30.1503L15.4203 31.2926L11.5625 29.4648L12.9127 30.5711L15.6494 32.459H20.339L23.0877 30.5711L24.4258 29.4648L20.5801 31.2926Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.279 27.4566L19.7003 27.0479H16.3006L15.722 27.4566L15.3965 30.1502L15.6979 29.8856H20.3031L20.6166 30.1502L20.279 27.4566Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.576 13.2075L33.6008 8.22934L32.0576 3.59985L20.2793 12.3177L24.8122 16.1415L31.2137 18.0054L32.6242 16.358L32.0094 15.9131L32.9859 15.0233L32.2385 14.4461L33.215 13.7005L32.576 13.2075Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 8.22934L3.43718 13.2075L2.77412 13.7005L3.76268 14.4461L3.01523 15.0233L3.99173 15.9131L3.37689 16.358L4.78741 18.0054L11.189 16.1415L15.7219 12.3177L3.94352 3.59985L2.40039 8.22934Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2133 18.0054L24.8118 16.1416L26.7407 19.0516L23.8594 24.667L27.669 24.619H33.3592L31.2133 18.0054Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1896 16.1416L4.78814 18.0054L2.6543 24.619H8.3325L12.142 24.667L9.26079 19.0516L11.1896 16.1416Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8689 19.3642L20.2788 12.3177L22.1354 7.30347H13.8652L15.7218 12.3177L16.1317 19.3642L16.2884 21.5767L16.3005 27.0479H19.7001L19.7122 21.5767L19.8689 19.3642Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.29e246ce06f0f5e39f9942d24058d10b.svg";
export { ForwardRef as ReactComponent };